var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6.25C11.75 7.76643 10.5164 9 9 9C7.48357 9 6.25 7.76643 6.25 6.25C6.25 4.73357 7.48357 3.5 9 3.5C10.5164 3.5 11.75 4.73357 11.75 6.25Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.9446C4.05357 12.6166 6.33929 11 8.99107 11C11.6429 11 13.9643 12.6443 15 15",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58272 4.58272 1 9 1C13.4173 1 17 4.58272 17 9C17 13.4173 13.4173 17 9 17C4.58272 17 1 13.4173 1 9Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileLine);
export default __webpack_public_path__ + "static/media/icon-profile-line.44d5643f3d646d6c7194a3a7b0d2dfef.svg";
export { ForwardRef as ReactComponent };